import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import UniversityHomePage from './pages/UniversityHomePage';
import AgencyHomePage from './pages/AgencyHomePage';
import FormComponent from './components/FormComponentTemp';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import BeneficiaryPage from './pages/BeneficiaryPage';
import RemitterPage from './pages/RemitterPage';
import SettingsPage from './pages/SettingsPage';
import TransactionPage from './pages/TransactionPage';
import PrivateRoute from './components/PrivateRoute';
import { Toaster } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import { checkSession, logout } from './@redux/Action/Config';
import { beneficiaryInsertReset } from './@redux/Reducer/beneficiary';
import { fxRateReset } from './@redux/Reducer/FX_Rate_Reducer';
import { remitterReset } from './@redux/Reducer/Remitter';
import { resetConfig } from './@redux/Reducer/Config';
import { resetOcrState, resetUID } from './@redux/Reducer/ocrReducer';

function App() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const sessionValid = useSelector(state => state.config?.sessionValid);
    const studentId = useSelector(state => state.config.studentId);

    // Reset all states if user accesses protected routes without onboarding
    useEffect(() => {
        const protectedPaths = ['/','/form', '/dashboard', '/profile', '/beneficiary', '/remitter', '/transaction', '/setting'];
        if (protectedPaths.includes(location.pathname) && !sessionStorage.getItem('onboardingCompleted')) {
            dispatch(beneficiaryInsertReset());
            dispatch(fxRateReset());
            dispatch(remitterReset());
            dispatch(resetUID());
            dispatch(resetOcrState());
        }
    }, [location.pathname, dispatch]);

    useEffect(() => {
        if(!sessionValid) {
            dispatch(resetConfig());
            dispatch(remitterReset());
        }
    }, [sessionValid, dispatch]);    

    // Automatically check session every hour
    useEffect(() => {
        // Don't check session if on onboarding page
        if (!window.location.pathname.includes('/onboarding')) {
            dispatch(checkSession()); // Check session on app load

            const intervalId = setInterval(() => {
                dispatch(checkSession());
            }, 3600 * 1000); // 1 hour

            return () => clearInterval(intervalId);
        }
    }, [dispatch]);

    // Logout if session becomes invalid
    useEffect(() => {
        // Don't logout if on onboarding page
        if (!window.location.pathname.includes('/onboarding') && sessionValid === false) {
            dispatch(logout(navigate));
        }
    }, [sessionValid, dispatch, navigate]);

    const protectedRoutes = [
        { path: "/form", element: <FormComponent studentId={studentId} /> },
        { path: "/dashboard", element: <Dashboard studentId={studentId} /> },
        { path: "/profile", element: <Profile studentId={studentId} /> },
        { path: "/beneficiary", element: <BeneficiaryPage studentId={studentId} /> },
        { path: "/remitter", element: <RemitterPage studentId={studentId} /> },
        { path: "/transaction", element: <TransactionPage studentId={studentId} /> },
        { path: "/setting", element: <SettingsPage studentId={studentId} /> }
    ];

    return (
        <div className="w-100 overflow-auto" style={{ maxHeight: "100vh" }}>
            <Routes>
                <Route
                    path="/"
                    element={
                        sessionValid ?
                        <Navigate to="/dashboard" replace /> :
                        <UniversityHomePage studentId={studentId} />
                    }
                />
                <Route
                    path="/agency"
                    element={
                        sessionValid ?
                        <Navigate to="/dashboard" replace /> :
                        <AgencyHomePage studentId={studentId} />
                    }
                />
                {/* Onboarding route without session check */}
                {/* <Route path="/onboarding" element={<Onboarding studentId={studentId} />} /> */}

                {protectedRoutes.map(({ path, element }) => (
                    <Route
                        key={path}
                        path={path}
                        element={<PrivateRoute>{element}</PrivateRoute>}
                    />
                ))}

                <Route path="/*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster
  position="top-center"
                reverseOrder={false}
            />
        </div>
    );
}

export default App;

